/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies.
 */
import PaddingControl from '../padding-control';
import { Component } from '@wordpress/element';

/**
 * Margin controls
 */
class MarginControl extends Component {
	render() {
		return <PaddingControl { ...this.props } label={ __( 'Margin' ) } property="margin" />;
	}
}

export default MarginControl;
